module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/a99d5051d0ec5624ea9705ff6b1d4571.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_visible.svg
// module id = +wqE
// module chunks = 0